module.exports = __webpack_public_path__ + "./images/a764027fde1cb8429f24ad7d68b5aab7.webp";